import * as yup from 'yup';

import { SUPPORTED_FORMATS, ATTACHMENT_MAX_FILE_NAME_LENGTH } from '../../../config';
import startupConfig from '../../../config/startupConfig';

export const validateFilesLength = (value) => {
  const maxFilesCount = startupConfig.get().trustDeedAttachment.maxFilesCount;
  let error;
  if ((value && value.length) > maxFilesCount) {
    error = `A maximum of ${maxFilesCount} files is allowed`;
  }
  return error;
};

export const trustValidationSchema = (props) => {
  const {
    trustDeedAttachmentConfig: { maxFileSizeInMb },
  } = props;
  const maxFileSize = maxFileSizeInMb * 1048576;

  return yup.object().shape({
    files: yup
      .array()
      .of(
        yup
          .mixed()
          .test('maxFileSize', `The maximum file size allowed is ${maxFileSizeInMb}MB`, (value) => {
            const isValid = value && value.size <= maxFileSize;
            return isValid;
          })
          .test('minFileSize', 'The file must not be empty', (value) => {
            const isValid = value && value.size > 0;
            return isValid;
          })
          .test(
            'fileFormat',
            `The supported file types are ${SUPPORTED_FORMATS.toString()}`,
            (value) => value && SUPPORTED_FORMATS.includes(value.type),
          )
          .test(
            'fileName',
            `The maximum length of a file name is ${ATTACHMENT_MAX_FILE_NAME_LENGTH} characters`,
            (value) => value.name.length <= ATTACHMENT_MAX_FILE_NAME_LENGTH,
          ),
      )
      .test({
        name: 'files-length',
        test: (value) => {
          const errorMessage = validateFilesLength(value);
          return !errorMessage;
        },
      }),
  });
};
